var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Tajikistan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#33691e",
    d: "M42.325,32H5.675C8.763,39.061,15.801,44,24,44S39.237,39.061,42.325,32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M44,24c0-2.846-0.604-5.549-1.675-8H5.675C4.604,18.451,4,21.154,4,24s0.604,5.549,1.675,8h36.649 C43.396,29.549,44,26.846,44,24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M24,4C15.801,4,8.763,8.939,5.675,16h36.649C39.237,8.939,32.199,4,24,4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M26.512,25.84c-0.227,0.211-0.52,0.344-0.828,0.371c-0.766,0.07-1.441-0.496-1.512-1.266V23.84 c0.008-0.254,0.219-0.453,0.473-0.445c0.156,0.004,0.301,0.09,0.383,0.227c0.188-0.566-0.121-1.18-0.688-1.367 c-0.566-0.191-1.18,0.117-1.367,0.688c-0.07,0.219-0.07,0.461,0,0.68c0.129-0.219,0.41-0.293,0.629-0.164 c0.137,0.078,0.223,0.227,0.227,0.383v1.105c-0.07,0.77-0.746,1.336-1.512,1.266c-0.309-0.027-0.602-0.16-0.828-0.371 c-0.297,0.742-1.137,1.105-1.879,0.809c-0.109-0.043-0.215-0.098-0.309-0.168c0.133,1.34,2.133,1.066,2.285-0.234 c0.625,1.105,2.008,0.789,2.41-0.566h0.008c0.402,1.355,1.785,1.672,2.41,0.566c0.152,1.301,2.152,1.574,2.285,0.234 c-0.098,0.07-0.199,0.125-0.309,0.168C27.648,26.945,26.809,26.582,26.512,25.84z M23.219,23.141 c0.051-0.352,0.324-0.625,0.676-0.676c0.43-0.059,0.828,0.246,0.887,0.676c-0.309-0.063-0.621,0.078-0.781,0.352 C23.844,23.219,23.527,23.078,23.219,23.141z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M22.492,27.32c0,0-0.141-0.082-0.434-0.047c-0.043-0.188-0.211-0.352-0.328-0.434 c-0.117,0.125-0.195,0.355-0.156,0.523c-0.211,0.039-0.406,0.18-0.406,0.18C21.656,28.031,22.215,27.926,22.492,27.32z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M24.676,27.254c0,0-0.125-0.109-0.422-0.117c-0.012-0.195-0.148-0.387-0.254-0.484 c-0.133,0.105-0.25,0.32-0.238,0.492c-0.215,0.004-0.43,0.109-0.43,0.109C23.734,27.816,24.301,27.805,24.676,27.254z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M26.84,27.543c0,0-0.105-0.125-0.395-0.184c0.02-0.195-0.086-0.406-0.172-0.52 c-0.148,0.082-0.301,0.277-0.316,0.449c-0.211-0.031-0.441,0.035-0.441,0.035C25.82,27.945,26.383,28.023,26.84,27.543z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M20.348,28.344L20.543,29c2.262-0.676,4.652-0.676,6.914,0l0.195-0.656 C25.262,27.629,22.738,27.629,20.348,28.344z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M23.668,20.027l-0.207,0.637L24,20.27l0.539,0.395l-0.207-0.637l0.539-0.391h-0.664L24,19 l-0.207,0.637h-0.664L23.668,20.027z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M21.102,20.719l-0.203,0.633l0.539-0.391l0.535,0.391l-0.203-0.633l0.539-0.395h-0.668l-0.203-0.633 l-0.207,0.633h-0.668L21.102,20.719z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M19.227,22.602l-0.207,0.637l0.539-0.395l0.539,0.395l-0.207-0.637l0.539-0.391h-0.664l-0.207-0.637 l-0.207,0.637h-0.664L19.227,22.602z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M18.871,25.418l0.539,0.395l-0.207-0.637l0.539-0.395h-0.664l-0.207-0.633l-0.207,0.633H18 l0.539,0.395l-0.207,0.637L18.871,25.418z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M26.23,20.719l-0.203,0.633l0.539-0.391l0.535,0.391l-0.203-0.633l0.539-0.395H26.77l-0.207-0.633 l-0.203,0.633h-0.668L26.23,20.719z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M28.109,22.602l-0.207,0.637l0.539-0.395l0.539,0.395l-0.207-0.637l0.539-0.391h-0.664l-0.207-0.637 l-0.207,0.637H27.57L28.109,22.602z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M29.461,25.176L30,24.781h-0.664l-0.207-0.633l-0.207,0.633h-0.664l0.539,0.395l-0.207,0.637 l0.539-0.395l0.539,0.395L29.461,25.176z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Tajikistan);
export default __webpack_public_path__ + "static/media/icons8-tajikistan.38fee53e03a972da9d544ea367ad7ecb.svg";
export { ForwardRef as ReactComponent };